import { Toolbar} from '@mui/material';
  import styled from '@emotion/styled';

export const ToolbarStyled = styled(Toolbar)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 16px 0;
//some //


`